export enum FeatureAnalysisScoreMode {
  Show = "show",
  Hide = "hide",
}
